import { useEffect, useState } from "react";
import api from "@/lib/api";

// Fetches Firmen / Mitarbeiter / Kategorien for use as selectable options in forms.
export function useStammdaten() {
  const [data, setData] = useState({ companies: [], employees: [], categories: [] });
  useEffect(() => {
    let alive = true;
    Promise.all([api.get("/companies"), api.get("/employees"), api.get("/categories")])
      .then(([c, e, k]) => alive && setData({ companies: c.data || [], employees: e.data || [], categories: k.data || [] }))
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return data;
}
